/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2BondPool extends Contract<ITestSolvV2BondPool> {
  getSettlePrice: Call<(_slot: BigNumberish) => BigNumber, ITestSolvV2BondPool>
  'getSettlePrice(uint256)': Call<(_slot: BigNumberish) => BigNumber, ITestSolvV2BondPool>
  oracle: Call<() => string, ITestSolvV2BondPool>
  'oracle()': Call<() => string, ITestSolvV2BondPool>
  refund: Send<(_slot: BigNumberish) => void, ITestSolvV2BondPool>
  'refund(uint256)': Send<(_slot: BigNumberish) => void, ITestSolvV2BondPool>
  setFundCurrency: Send<(_currency: AddressLike, _enable: boolean) => void, ITestSolvV2BondPool>
  'setFundCurrency(address,bool)': Send<(_currency: AddressLike, _enable: boolean) => void, ITestSolvV2BondPool>
  setSettlePrice: Send<(_slot: BigNumberish) => void, ITestSolvV2BondPool>
  'setSettlePrice(uint256)': Send<(_slot: BigNumberish) => void, ITestSolvV2BondPool>
}

let ITestSolvV2BondPoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2BondPoolBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2BondPool = contract<ITestSolvV2BondPool>(ITestSolvV2BondPoolBytecode)`
  function getSettlePrice(uint256 _slot) view returns (uint128 settlePrice_)
  function oracle() view returns (address oracle_)
  function refund(uint256 _slot)
  function setFundCurrency(address _currency, bool _enable)
  function setSettlePrice(uint256 _slot)
`;